<template>
  <el-dialog :title="$t('buildingForm.add.title')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.add.buildingName')" prop="buildingName">
            <el-input v-model="form.buildingName" :placeholder="$t('buildingForm.add.buildingNamePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.add.userName')" prop="userName">
            <el-input v-model="form.userName" :placeholder="$t('buildingForm.add.userNamePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.add.userTel')" prop="userTel">
            <el-input v-model="form.userTel" :placeholder="$t('buildingForm.add.userTelPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.add.statusCd')" prop="statusCd">
            <el-select v-model="form.statusCd" :placeholder="$t('buildingForm.add.statusCdPlaceholder')" style="width:100%">
              <el-option :label="$t('buildingForm.status.valid')" value="0" />
              <el-option :label="$t('buildingForm.status.invalid')" value="1" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { createBuildingForm } from '@/api/oa/buildingFormApi'

export default {
  name: 'AddBuildingForm',
  data() {
    return {
      dialogVisible: false,
      form: {
        buildingName: '',
        userName: '',
        userTel: '',
        statusCd: '0',
        communityId: ''
      },
      rules: {
        buildingName: [
          { required: true, message: this.$t('buildingForm.validate.buildingNameRequired'), trigger: 'blur' },
          { max: 100, message: this.$t('buildingForm.validate.buildingNameMaxLength'), trigger: 'blur' }
        ],
        userName: [
          { required: true, message: this.$t('buildingForm.validate.userNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('buildingForm.validate.userNameMaxLength'), trigger: 'blur' }
        ],
        userTel: [
          { required: true, message: this.$t('buildingForm.validate.userTelRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('buildingForm.validate.userTelFormat'), trigger: 'blur' },
          { max: 20, message: this.$t('buildingForm.validate.userTelMaxLength'), trigger: 'blur' }
        ],
        statusCd: [
          { required: true, message: this.$t('buildingForm.validate.statusCdRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.form.communityId = getCommunityId()
            await createBuildingForm(this.form)
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('保存房产留资失败:', error)
            this.$message.error(this.$t('common.operationFailed'))
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
</style>